'use client';

import { ReactNode } from 'react';
import { Root, Portal, Overlay, Content, Close, Title, Description } from '@radix-ui/react-dialog';
import Button from './Button';
import { CloseIcon } from './icons/CloseIcon';

export const ConfirmDialog = ({
  open,
  onClose,
  title,
  text,
  onSubmit,
  isLoading,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  text: ReactNode;
  isLoading?: boolean;
}) => {
  return (
    <Root open={open}>
      <Portal>
        <Overlay className="fixed inset-0 bg-neutral-black bg-opacity-90 z-50 grid items-center justify-center overflow-y-auto p-24 animate__animated animate__fadeIn">
          <Content
            className={`z-50 sm:w-unset w-screen relative sm:w-fit sm:min-w-[480px] max-w-[640px] font-medium bg-neutral-950 rounded-xl animate__animated animate__fadeInUp animate__delay-0.3s animate__faster font-secondary`}
          >
            <div className="flex items-center justify-between w-full border-b-[1px] border-neutral-800 p-8">
              <Title>
                <p className="text-white">{title}</p>
              </Title>
              <Close className="text-white m-l-auto" onClick={onClose}>
                <CloseIcon />
              </Close>
            </div>
            <Description className="text-neutral-300 p-8">{text}</Description>
            <div className="p-8 flex items-center justify-between gap-5">
              <Button filled={false} onClick={onClose} className="w-full" disabled={isLoading}>
                Cancel
              </Button>
              <Button onClick={onSubmit} className="w-full" disabled={isLoading}>
                {isLoading ? 'Loading' : 'Confirm'}
              </Button>
            </div>
          </Content>
        </Overlay>
      </Portal>
    </Root>
  );
};
